// modules import
import './polyfill/polyfill';
import ProductSwitch from './modules/product-switch';
import Carousel from './modules/carousel';
import Accordion from './modules/accordion';
import PostalcodeValidate from './modules/postalcode-validate';
import InputTextSelector from './modules/input-text-selector';
import EfeedbackSearchPanel from './modules/efeedback-search-panel';
import CookieConsentObserver from './modules/cookie-consent-observer';
import LoginTrigger from './modules/login-trigger';
import LazyImageLoader from './modules/lazy-image-loader';
import NavigationBar from './modules/navigation-bar';
import DefaultInput from './modules/default-input';
import TextSize from './modules/text-size';
import LetterNav from './modules/letter-nav';
import ModalBox from './modules/modalBox';
import WaypointObserver from './modules/waypoint-observer';
import CreditCardFormLogic from './modules/creditCardFormLogic';
import MatomoEventsCc from './modules/matomo-events-cc';
import Chatty from './modules/chatty';
import Onboarding from './modules/onboarding';

// modules init
new ProductSwitch();
new Carousel();
new WaypointObserver();
new Accordion().init();
new PostalcodeValidate().init();
new InputTextSelector();
new EfeedbackSearchPanel();
new CookieConsentObserver();
new LoginTrigger();
new LazyImageLoader();
new NavigationBar();
new DefaultInput();
new TextSize();
new LetterNav();
new ModalBox();
new CreditCardFormLogic();
new Chatty('desktop');
new Onboarding();

new MatomoEventsCc();

